
export function formatDate (date, fmt) {
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'S': date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
    }
  }
  return fmt;
}

export function format(time) {
  time=JSON.parse(time);
  var date = new Date(time);
  return formatDate(date, 'yyyy-MM-dd hh:mm');
}

export function format2Sec(time) {
  let date = new Date(time);
  return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
}

export function formatSex(sex){ //具体化性别
  if(sex===0){
    return "未知";
  }else if(sex===1){
    return "男";
  }else{
    return "女";
  }
}

export function formatStatus(status){ //具体化状态
  if(status===0){
    return "禁用";
  }else{
    return "启用";
  }
}

export function formatAskWay(askWay){ //具体化求助方式
  switch (askWay){
    case 1:
      return "图片 + 文字";
    case 2:
      return "图片 + 语音";
    case 3:
      return "短视频";
    case 4:
      return "实时视频";
  }
}



// WEBPACK FOOTER //
// ./src/utils/format.js